export const BOT_NAME = 'Itria Assistant';

export const QUICK_ACTIONS = [
  { id: 'book_cleaning', label: 'Book a cleaning' },
  { id: 'check_pricing', label: 'Check Pricing' },
  { id: 'our_services', label: 'Our Services' },
  { id: 'how_it_works', label: 'How it works' },
  { id: 'help_support', label: 'Help & support' },
] as const;

export const SESSION_STORAGE_KEY = 'itria-chatbot-session';
export const ANONYMOUS_ID_KEY = 'itria-chatbot-anonymous-id';
export const SESSION_IDLE_MS = 30 * 60 * 1000;

export function isChatbotEnabled(): boolean {
  return import.meta.env.VITE_WEBSITE_CHATBOT_ENABLED === 'true';
}

export function shouldShowChatbot(pathname: string): boolean {
  if (!isChatbotEnabled()) return false;
  if (pathname.startsWith('/embed')) return false;
  if (pathname.startsWith('/checkr')) return false;
  return true;
}
